import clsx from 'clsx';

import { type Team } from '@common/clients/api';
import { Route } from '@common/types/Route';
import { InternalLink } from '@web/atoms/InternalLink';
import { TagImage } from '@web/atoms/TagImage';
import styles from '@web/molecules/FootballFormation/FootballFormation.module.scss';

interface Props {
    className?: string;
    team: Pick<Team, 'tag'>;
}

export const TeamLogo = ({ className, team }: Props) => {
    const containerClassName = clsx(styles['team-logo'], className);

    return team.tag?.tagSlug ? (
        <InternalLink className={containerClassName} route={Route.Club} params={{ slug: team.tag?.tagSlug }}>
            <TagImage tag={team.tag} />
        </InternalLink>
    ) : (
        <span className={containerClassName}>
            <TagImage tag={team.tag} />
        </span>
    );
};
